import { toast } from 'sonner';
import { APP_TOASTER_ID } from './appToastConstants';
import {
  enqueueAppToast,
  flushAppToastQueue,
  isAppToasterMounted,
} from './appToastMountState';

export { APP_TOASTER_ID } from './appToastConstants';
const DEFAULT_TOAST_TYPE = 'info';
const DEFAULT_TOAST_DURATION = 3000;

const TOAST_HANDLERS = {
  default: toast,
  error: toast.error,
  info: toast.info,
  loading: toast.loading,
  success: toast.success,
  warning: toast.warning,
};

function normalizeToastOptions(typeOrOptions = DEFAULT_TOAST_TYPE) {
  if (typeof typeOrOptions === 'string') {
    return { type: typeOrOptions };
  }

  if (typeOrOptions && typeof typeOrOptions === 'object') {
    return {
      ...typeOrOptions,
      type: typeOrOptions.type || DEFAULT_TOAST_TYPE,
    };
  }

  return { type: DEFAULT_TOAST_TYPE };
}

function dispatchAppToast({ message, type, options }) {
  const toastHandler = TOAST_HANDLERS[type] || toast;
  return toastHandler(message, options);
}

export function showAppToast(message, typeOrOptions) {
  if (!message) return null;

  const { type, ...options } = normalizeToastOptions(typeOrOptions);
  const toastOptions = {
    toasterId: APP_TOASTER_ID,
    duration: DEFAULT_TOAST_DURATION,
    ...options,
  };

  if (!isAppToasterMounted()) {
    return enqueueAppToast({
      message,
      type,
      options: toastOptions,
    });
  }

  return dispatchAppToast({
    message,
    type,
    options: toastOptions,
  });
}

export function flushQueuedAppToasts() {
  return flushAppToastQueue(dispatchAppToast);
}

export function dismissAppToast(toastId) {
  return toast.dismiss(toastId);
}

/**
 * Copy-to-clipboard failure notice, owned in one place.
 *
 * Copy fails closed for a layered asset rather than handing over the un-masked original,
 * so every copy entry point must say something. Three surfaces call this — grid, canvas,
 * and the canvas export hook — and a per-surface copy of the string is how they drift.
 */
export function notifyCopyFailed() {
  showAppToast('Could not copy this asset to the system clipboard.', { type: 'error' });
}
